import React from 'react';
import c from 'classnames';

import { CoreLink } from '@uncinc/react-drupal-core';

import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

export interface IconCardProps {
  title: string,
  description?: string | null,
  href: string,
  icon?: string,
  iconAlt: string,
  classNames?: string,
  onClick?: () => void;
  small?: boolean,
  richText?: boolean,
}

const IconCard: React.FC<IconCardProps> = ({
  title,
  description,
  href,
  icon,
  iconAlt,
  classNames = '',
  onClick,
  richText = false,
  small = false,
}) => (
  <div className={c('IconCard', classNames, {
    'IconCard--small': small,
  })}
  >
    <CoreLink href={href} onClick={onClick} className="IconCard__link">
      <div className="IconCard__inner">
        <h3>{title}</h3>

        {description && (
          <div className="body--regular IconCard__description">
            {richText ? (
              <WysiwygField
                property="schema:text"
                html={description}
              />
            ) : (
              <p>{description}</p>
            )}
          </div>
        )}

        {icon && (
          <img src={icon} alt={iconAlt} />
        )}

        <div className="IconCard__arrow"><span className="icon icon-arrow-right" /></div>
      </div>
    </CoreLink>
  </div>
);

export default IconCard;
